/* eslint-disable no-use-before-define */

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import clickOutside from 'click-outside';
import { up, down } from 'slide-element';
import { createFocusTrap } from 'focus-trap';
import geolocate, { setRegionByPostalCode } from './geolocation';
import notifyGeolocationFailed from './geolocation-popup';

const $body = document.querySelector('body');
const $panel = document.querySelector('.geolocation-panel');
const $closeBtn = $panel?.querySelector('.btn-close');
const $warning = $panel?.querySelector('.geolocation-panel-warning');
const $closeBtnWarning = $warning?.querySelector('.btn-close-warning');
const $btnGeolocate = $panel?.querySelector('.btn-ask-location');
const $regionsList = $panel?.querySelector('.geolocation-panel-regions-list');
const $btnRegions = $panel?.querySelector('.btn-regions');
const $locationInput = $panel?.querySelector('#location');
const $btnSubmit = $panel?.querySelector('.btn-submit');
const $locationError = $panel?.querySelector('.geolocation-panel-error');

let unbindClickOutside;
let focusTrap;
let focusTrapTimeout;

async function getRegions() {
    if (!$regionsList) return;

    $btnRegions?.classList.add('hidden');
    $regionsList.classList.add('visible');

    if ($regionsList.children.length > 1) return;

    const response = await fetch(window.ajax_script?.ajaxurl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'action=get_sgbdf_regions',
    });
    const json = await response.json();

    if (!json.success) return;

    $regionsList.innerHTML = '';

    json.data.regions.forEach((region) => {
        if (!region.slug) return;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'btn-region';
        btn.dataset.slug = region.slug;
        btn.innerHTML = `${region.label}<span><svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.92871 0.292745C9.31914 -0.0976805 9.95223 -0.0974828 10.3428 0.292745L16.707 6.657C17.0976 7.04753 17.0976 7.68054 16.707 8.07106L10.3428 14.4353C9.95223 14.8256 9.31914 14.8257 8.92871 14.4353C8.53829 14.0449 8.53848 13.4118 8.92871 13.0213L13.5859 8.36403H0V6.36403H13.5859L8.92871 1.70681C8.53848 1.31626 8.53829 0.68317 8.92871 0.292745Z" fill="#041740"/></svg></span>`;
        btn.addEventListener('click', () => {
            const expires = new Date(Date.now() + 31536000 * 1000).toUTCString();
            document.cookie = `fadoq_region=${btn.dataset.slug}; expires=${expires}; path=/`;
            window.location.reload();
        });
        $regionsList.appendChild(btn);
    });
}

function onEscape(event) {
    if (event.key === 'Escape') {
        closePanel();
        window.removeEventListener('keydown', onEscape);
    }
}

function closePanel() {
    $panel.inert = true;
    $panel.classList.remove('opened');
    $body.classList.remove('with-geolocation-overlay');
    enableBodyScroll($panel);
    clearTimeout(focusTrapTimeout);
    focusTrap?.deactivate();

    $regionsList.innerHTML = '<span class="geolocation-panel-loading"></span>';
    $regionsList.classList.remove('visible');
    $btnRegions?.classList.remove('hidden');
    $locationError.hidden = true;

    if (unbindClickOutside) {
        unbindClickOutside();
        unbindClickOutside = null;
    }

    window.removeEventListener('keydown', onEscape);
}

function openPanel() {
    $panel.inert = false;
    $panel.classList.add('opened');
    $body.classList.add('with-geolocation-overlay');
    disableBodyScroll($panel, {
        allowTouchMove: (el) => $panel.contains(el),
    });

    document.dispatchEvent(new CustomEvent('fadoq:geolocationPanelOpened'));

    unbindClickOutside = clickOutside($panel, () => {
        closePanel();
    });

    window.addEventListener('keydown', onEscape);

    focusTrapTimeout = setTimeout(() => {
        focusTrap = createFocusTrap($panel, {
            clickOutsideDeactivates: true,
            preventScroll: true,
        });
        focusTrap.activate();
    }, 100);
}

document.querySelectorAll('.button-locations').forEach(($btn) => {
    $btn.addEventListener('click', (event) => {
        event.stopPropagation();
        openPanel();
    });
});

$closeBtn?.addEventListener('click', closePanel);

document.querySelectorAll('.btn-current-location').forEach(($btn) => {
    $btn.addEventListener('click', closePanel);
});
$btnRegions?.addEventListener('click', getRegions);

document.addEventListener('fadoq:megaMenuOpened', closePanel);
document.addEventListener('fadoq:openGeolocationPanel', openPanel);

function showLocationWarning() {
    $btnGeolocate.disabled = true;
    down($warning, { display: 'flex' });
}

if (!document.cookie.split('; ').find((c) => c.startsWith('fadoq_region='))) {
    geolocate({
        onError: () => {
            showLocationWarning();
            notifyGeolocationFailed();
        },
    });
}

$closeBtnWarning?.addEventListener('click', () => {
    up($warning);
});

$btnGeolocate?.addEventListener('click', () => {
    geolocate({ onError: showLocationWarning });
});

const postalCodeRegex = /^[a-zA-Z]\d[a-zA-Z][ -]?\d[a-zA-Z]\d$/;

async function handleLocationSearch() {
    const text = $locationInput?.value?.trim();
    if (!text) return;

    if (!postalCodeRegex.test(text)) {
        $locationError.hidden = false;
        return;
    }

    $locationError.hidden = true;
    await setRegionByPostalCode(text);
}

$btnSubmit?.addEventListener('click', handleLocationSearch);
$locationInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        handleLocationSearch();
    }
});
